module.exports = __webpack_public_path__ + "static/media/plus.b1dce8d2.svg";